import * as React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';

import { withStyles, TextField, Button } from '@material-ui/core';

import * as PatientStore from '../../../app/store/PatientStore';
import { getValueByDotNotation } from '../../../youwell-common/objectUtils';

const styles = theme => ({
    root: {
    },
    actions: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(1),
        display: 'flex',
        justifyContent: 'flex-end',
    },
    addIcon: {
        marginRight: theme.spacing(1),
    },
    divider: {
        marginTop: theme.spacing(1),
    },
});

const stateFromData = (data, name) => ({
    validationErrors: {},
    hasUnsavedChanges: false,
    saveMessage: '',
    value: getValueByDotNotation(data, name),
});

class EditDetails extends React.Component {
    state = stateFromData(this.props.studentData, this.props.detailName);

    handleChange = (event) => {
        this.setState({ value: event.target.value, hasUnsavedChanges: true });
    }

    save = () => {
        const { studentData, detailName, onClose } = this.props;

        const data = {
            id: studentData.id,
            rev: studentData.rev,
            changes: {
                [detailName]: this.state.value,
            },
        };

        this.props.patchElement(data, { callback: onClose });
    }

    render() {
        const {
            classes, translate, studentData,
        } = this.props;

        if (!studentData) {
            return null;
        }

        return (
            <div className={classes.root}>
                <TextField
                    multiline
                    fullWidth
                    minRows={20}
                    value={this.state.value || ''}
                    onChange={this.handleChange}
                />
                <div className={classes.actions}>
                    <Button variant="contained" color="secondary" onClick={this.save} disabled={!this.state.hasUnsavedChanges}>
                        {translate('infobox.save')}
                    </Button>
                </div>

            </div>
        );
    }
}

EditDetails.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            studentId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    studentData: PropTypes.object.isRequired,
    detailName: PropTypes.string.isRequired,
    patchElement: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
    translate: getTranslate(state.localize),
    studentData: state.patient.details && state.patient.details[ownProps.match.params.studentId],
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(PatientStore.actionCreators, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditDetails)));
